/**
 * aerobis: after add-to-cart, open the Impact cart drawer.
 * Keeps the popover confirmation closed. Does not show a toast.
 * Single opener: theme CartDrawer / CartNotificationDrawer are blocked,
 * then this script calls cart-drawer.show() on cart:change (covers PDP,
 * collection, complementary AJAX, and quick-buy).
 */
(function () {
  if (window.aerobisCartToast) return;

  function cartDrawer() {
    return document.getElementById("cart-drawer") || document.querySelector("cart-drawer");
  }

  function isQuickBuy(el) {
    return !!(el && el.tagName === "QUICK-BUY-DRAWER");
  }

  function closeQuickBuy(from) {
    var host = from && from.closest && from.closest("quick-buy-drawer");
    if (isQuickBuy(host) && typeof host.hide === "function") {
      host._hasLoaded = false;
      host.hide();
    }
  }

  function closeOpenQuickBuys() {
    document.querySelectorAll("quick-buy-drawer").forEach(function (el) {
      if (typeof el.hide !== "function") return;
      el._hasLoaded = false;
      el.hide();
    });
  }

  function openCartDrawer() {
    var drawer = cartDrawer();
    if (drawer && typeof drawer.show === "function") return drawer.show();
    return null;
  }

  function blockThemeOpeners(event) {
    if (!event.detail) event.detail = {};
    event.detail.blockCartDrawerOpening = true;
    closeQuickBuy(event.target);
  }

  function onCartChange(event) {
    if (!event.detail || event.detail.baseEvent !== "variant:add") return;
    closeOpenQuickBuys();
    openCartDrawer();
  }

  function patchWhenDefined(name, patch) {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined(name).then(function () {
      var Ctor = customElements.get(name);
      if (Ctor && Ctor.prototype) patch(Ctor.prototype);
    });
  }

  document.addEventListener("variant:add", blockThemeOpeners, true);
  document.addEventListener("cart:change", onCartChange);

  patchWhenDefined("cart-notification-drawer", function (proto) {
    proto._onVariantAdded = function () {};
    proto.show = function () {
      return Promise.resolve();
    };
  });

  patchWhenDefined("quick-buy-drawer", function (proto) {
    proto._onVariantAdded = function (event) {
      blockThemeOpeners(event);
      this._hasLoaded = false;
      if (typeof this.hide === "function") this.hide();
    };
  });

  window.aerobisCartToast = {
    open: openCartDrawer
  };
})();
